export default __webpack_public_path__ + "static/media/logo_ocbbank.f2cf3c07.png";